import * as React from "react"
import { CopyButton, ThemeCss, StyledInput } from "gatsby-interface"

const baseCss: ThemeCss = theme => ({
  display: "flex",
  background: theme.colors.white,
  width: "100%",
  gap: theme.space[3],
})

const urlCss: ThemeCss = theme => ({
  flex: `1 1 auto`,
  fontFamily: theme.fonts.monospace,
  fontSize: theme.fontSizes[1],
  overflowX: "scroll",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
})

export type CopyUrlProps = {
  url: string
  urlDisplay?: string
  "data-cy-name"?: string
  "aria-describedby"?: string
  onClick?: () => void
}

export default function CopyUrl({
  url,
  urlDisplay = url,
  "data-cy-name": cyName = undefined,
  "aria-describedby": describedBy,
  onClick = () => undefined,
}: CopyUrlProps) {
  return (
    <div css={baseCss}>
      <StyledInput
        readOnly
        css={urlCss}
        value={urlDisplay}
        data-cy={cyName}
        aria-label="Webhook endpoint"
        aria-describedby={describedBy}
      />
      <CopyButton
        content={url}
        data-cy={cyName ? `${cyName}-button` : undefined}
        aria-label="Copy webhook endpoint"
        onClick={onClick}
      />
    </div>
  )
}
